import React from 'react';
import {Button} from "react-bootstrap";
import {GoogleReCaptchaProvider, withGoogleReCaptcha} from "react-google-recaptcha-v3";
import Footer from "../components/Footer";
import {reCAPTCHA_CLIENT} from "../constants";
import FAQs from "./FAQs";
import StarsBackdrop from "./StarsBackdrop.3";
import styles from './ThreeJSCompetition.module.css';

const ThreeJSCompComponent = () => {
  return <div className={styles.body}>
  <StarsBackdrop/>
    <div
      className={styles.threejsContainer}
    >
      <div className={styles.subContainer}>
        <div className={styles.hero}>
          <img src="assets/logo-white.png" height={40} /> <span style={{letterSpacing: 16, fontWeight:"lighter"}}>presents</span>
          <h1 className={styles.h1}>A three.js Competition</h1>
          <div className="text-center font-24 mt-3" style={{ maxWidth: 500, fontWeight:"lighter" }}>
            Upload and host your three.js project<br /> in seconds to <b>win $300!</b>
          </div>
          <div style={{ fontSize: 50}}>
            🤑
          </div>
          <a href="#enter">
            <Button className="mt-3 text-center" variant="outline-light">Enter competition</Button>
          </a>
        </div>
        <p className="mt-5 font-20 text-center">three.js is awesome, we all know that. But hosting your dazzling code can be a pain. That's why Tiiny Host exists, it's the simplest way to upload and host your web project and we’ve decided to reward the community for opening our eyes to the beauty of WebGL.</p>
        <div className="mt-5">
          <h2>What can I win?</h2>
          <div className="flex mt-5">
            <div className="flex-grow-1 text-center">
              <div style={{ fontSize: 40 }}>
                🥇
              </div>
              <div style={{ fontSize: 40, fontWeight: 'bold' }}>
                $300
              </div>
              <div className="text-sm">1st place</div>
            </div>
            <div className="flex-grow-1 text-center">
              <div style={{ fontSize: 40 }}>
                🥈
              </div>
              <div style={{ fontSize: 40, fontWeight: 'bold' }}>
                $200
              </div>
              <div className="text-sm">2nd place</div>
            </div>
            <div className="flex-grow-1 text-center">
              <div style={{ fontSize: 40 }}>
                🥉
              </div>
              <div style={{ fontSize: 40, fontWeight: 'bold' }}>
                $100
              </div>
              <div className="text-sm">3rd place</div>
            </div>
          </div>
        </div>
        <div id="enter" className="mt-5">
          <h2>
            To enter:
          </h2>
          <ol>
            <li>
              Enter your name, email address and website (if you have one)
            </li>
            <li>Drag and drop your three.js Zip file - Drag & drop or browse & select the Zip file you would like to host & share below.</li>
            <li>Verify ownership using the link sent to your registered email address and that’s it!</li>
            <li>Finally, tweet us with your link</li>
          </ol>
          <h3 className="white text-center mt-5">The competition is now closed.</h3>
        </div>
        <div className="mt-5">
          <h2>
            Judging panel
          </h2>
          <div className="flex mt-5">
            <div className="text-center flex-grow-1">
              <a href="https://twitter.com/Andersonmancini" target="_blank">
                <img
                  style={{ borderRadius: 50 }}
                  src="https://pbs.twimg.com/profile_images/1495074064234385409/BNHywXoZ_x96.jpg"
                  height="90"
                />
              </a>
              <div className="mt-3">Anderson Mancini</div>
            </div>
            <div className="text-center flex-grow-1">
              <a href="https://twitter.com/crnacura" target="_blank">
                <img
                  style={{ borderRadius: 50 }}
                  src="https://pbs.twimg.com/profile_images/1246296236157624321/I2_oSEZO_400x400.jpg"
                  height="90"
                />
              </a>
              <div className="mt-3">Manoela Ilic</div>
            </div>
            <div className="text-center flex-grow-1">
              <a href="https://twitter.com/0beqz" target="_blank">
                <img
                  style={{ borderRadius: 50 }}
                  src="https://pbs.twimg.com/profile_images/1314039475379613696/9-h_UjBn_400x400.jpg"
                  height="90"
                />
              </a>
              <div className="mt-3">0beqz</div>
            </div>
            <div className="text-center flex-grow-1">
              <a href="https://twitter.com/sketchpunklabs" target="_blank">
                <img
                  style={{ borderRadius: 50 }}
                  src="https://pbs.twimg.com/profile_images/938040944355454981/NkQOXqNq_400x400.jpg"
                  height="90"
                />
              </a>
              <div className="mt-3">VoR</div>
            </div>
          </div>
        </div>
        <div className={`mt-5 pt-5 ${styles.timeline}`}>
          <h2>What happens next?</h2>
          <div className={`mt-5 ps-5 pe-5 ${styles.timelineImg}`}>
            <img className="m-auto" src="assets/img/threejs-timeline.png" height={130}/>
          </div>
        </div>
        <FAQs />
      </div>
    <Footer/>
    </div>
  </div>
}

const ThreeJSCompWithReCaptcha = withGoogleReCaptcha(ThreeJSCompComponent);

const ThreeJSComp = () => <GoogleReCaptchaProvider reCaptchaKey={reCAPTCHA_CLIENT}>
  <ThreeJSCompWithReCaptcha />
</GoogleReCaptchaProvider>

export default ThreeJSComp;